<template>
    <div class="product-bundle-selector">
        <div role="radiogroup" aria-labelledby="qty">
            <swiper class="swiper" ref="swiper" :options="swiperOption" :auto-update="true" :auto-destroy="true" :delete-instance-on-destroy="true" :cleanup-styles-on-destroy="true">
                <swiper-slide v-for="(bundle, index) in promotions" :key="index" class="swiper-slide product-bundle-selector-card" :class="{'highlight-text': bundle.text,'selected': bundleSelected === index}">
                    <div
                        class="wrapper h-100"
                        role="radio"
                        :tabindex="bundleSelected === index ? 0 : -1"
                        :aria-checked="bundleSelected === index ? 'true' : 'false'"
                        @click="selectBundle(bundle, index)">
                        <div class="product-bundle-selector-card-header d-flex justify-content-center align-items-center">
                            <b-icon :icon="bundle.icon" class="mr-1" v-if="bundle.icon"></b-icon>
                            <span v-if="bundle.text">{{ bundle.text }}</span>
                        </div>
                        <div class="product-bundle-selector-card-body">
                            <div class="aspect-ratio" :class="[getClassAspectRatio]">
                                <div class="aspect-content">
                                    <img :src="imageUrl(product.gallery[0].image)" :class="$wdconfig.modules.product.image_object_fit" :alt="bundle.name" :title="bundle.name" loading="lazy">
                                </div>
                            </div>
                            <div class="product-bundle-selector-card-body-price p-2 d-flex flex-column justify-content-center align-items-center text-center">
                                <div class="unity pb-1">
                                    {{ bundle.quantity_initial }} {{ product.unit.name }}
                                </div>
                                <div class="product-price normal pb-1">
                                    {{ product.price * bundle.quantity_initial | currency }}
                                </div>
                                <div>
                                    <div class="product-price discount pb-1" v-if="bundle.quantity_initial > 1">
                                        {{ bundle.price | currency }} cada
                                    </div>
                                    <div class="product-price save pb-1" v-if="discount(bundle)">
                                        Economize {{ discount(bundle) | currency }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div class="swiper-pagination mt-2" :class="uid" slot="pagination" ref="pagination"></div>
    </div>
</template>

<script>
import utils from '~/mixins/utils';
export default {
    mixins: [
        utils
    ],
    props: {
        product: {
            required: true
        }
    },
    data() {
        return {
            bundleSelected: 0,
            promotions: []
        };
    },
    computed: {
        uid() {
            return `component-${this._uid}`;
        },
        swiperOption() {
            return {
                loop: false,
                centeredSlides: false,
                slidesPerView: '3',
                spaceBetween: 15,
                allowTouchMove: true,
                breakpoints: {
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 8
                    },
                    457: {
                        slidesPerView: 3,
                        spaceBetween: 8
                    },
                    576: {
                        slidesPerView: 3,
                        spaceBetween: 8
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 17
                    }
                },
                pagination: {
                    el: `.${this.uid}.swiper-pagination`,
                    clickable: true
                },
                navigation: {
                    nextEl: `.${this.uid}.swiper-button-next`,
                    prevEl: `.${this.uid}.swiper-button-prev`
                },
            };
        }
    },
    methods: {
        selectBundle(item, index) {
            this.bundleSelected = index;
            this.$emit('qty', item.quantity_initial)
        },
        discount(bundle) {
            const productPrice = Math.round(this.product.price * 100)
            const bundlePrice = Math.round(bundle.price * 100)
            const quantity = bundle.quantity_initial
            const discountCents = (productPrice - bundlePrice) * quantity
            return discountCents / 100
        }
    },
    created() {
        this.promotions = [{"quantity_initial": "1", "price": this.product.price, "text": "", "icon": ""}].concat(this.product.promotions)
    }
};
</script>

<style lang="scss">
@import "../assets/scss/variables";

.product-bundle-selector {
    height: 100%;

    .swiper-pagination {
        position: static;
    }

    .swiper {
        .swiper-wrapper {
            align-items: flex-end;
        }

        .swiper-slide {
            height: 100%;
            width: 168px;
        }
    }

    & [role=radio] {
        cursor: pointer;
    }

    &-card {
        &-header {
            color: white;
            font-weight: $font_medium;
            font-size: $font_size_text_small;
            height: 25px;
            border: 1px solid #BFBFBFDD;
            border-bottom: none;
            border-radius: 30px 30px 0 0;
        }

        &-body {
            overflow: hidden;
            border: 1px solid #BFBFBFDD;
            border-top: none;
            border-radius: 0 0 30px 30px;

            &-price {
                min-height: 95px;
                font-size: $font_size_text_small;
                color: #666666;

                .product-price {
                    font-weight: $font_regular;

                    &.normal {
                        color: #666666;
                        font-size: $font_size_text_small;
                    }

                    &.discount {
                        font-size: $font_size_text_medium;
                        font-weight: $font_bold;
                    }

                    &.save {
                        color: #666666;
                        font-size: 10px;
                    }
                }

            }
        }

        &.highlight-text{
            .product-bundle-selector-card-header {
                border: 1px solid $background_button_default;
                border-bottom: none ;
                background-color: $background_button_default;
                height: 35px;
            }
        }

        &.selected {
            .product-bundle-selector-card-header {
                border: 1px solid $background_button_default;
                border-bottom: none ;
            }
            .product-bundle-selector-card-body {
                border: 1px solid $background_button_default;
                border-top: none ;
            }
        }
    }

    & .swiper-pagination {
        & .swiper-pagination-bullet {
            width: 12px;
            height: 12px;
            margin: 0 4px;
        }
    }
}
</style>
